var global = global || {};

(function () {
    var _u = 'undefined';
    var _f = 'function';
    var _s = 'string';
    var _svgns = 'http://www.w3.org/2000/svg';
    var _xlnkns = 'http://www.w3.org/1999/xlink';

    var _div = 'div';
    var _span = 'span';
    var _button = 'button';
    var _iframe = 'iframe';
    var _required = 'required';
    var _body = 'body';
    var _popupEventHandler = 'popupEvent';

    var jQ = jQ || false;
    if (typeof jQuery !== _u) {
        jQ = jQuery;
    }

    global = (function (glb, $) {

        //#region Internal variables

        var _appWindow = tios.util.appWindow;//used to just refer to window.top //internal variable

        var _$lastToolTip = null;//placeholder for last shown tooltip

        var _usebodyblockaction = true;
        var _csssizingclass = 'csssize';

        // The default unload action (does nothing) - this is required as a minimum to prevent previous page caching
        var _defaultUnload = function () { };

        /// Queue for popups, if using queueing
        var _popupQueue = [];
        var _deferPopups = null; 
        var _popupCount = 0;// A globally incremented number for popups opened and closed via the queue. Incremented on popup open.
        var _currentlyOpenID = null;
        //#endregion

        //#region Public variables
        glb.hasParent = (window != window.parent);//is window in a parent?

        glb.loggingOut = false;//add to global definition
        
        glb.blockTimer = null;// this will hold the blockaction timer reference
        glb.blockTimeoutDuration = 60000;

        // If navigation blocking is set, this is the callback for the function to trigger on navigation/onbeforeunload
        glb.blockNavFn = null; //Do not modify this directy - it is the placeholder for the application-wide blocknav function

        // Popup parameters
        glb.deferPopups = null;// Whether to show queued popups or wait until they are triggered 'manually' - allows delay for high priority in-page alerts
        glb.popupWindowCloseArgs = null;
        glb.popupWindowInitialWidth = null;
        glb.popupWindowInitialHeight = null;

        glb.popupsBlocked = false;

        glb.pageVisited = false;

        // Object representing popups list - will contain ids of all open popups at the time. This is used
        // to trigger events when windows are opened/closed for other windows watching
        // If this is the app window, we initialise it to a new array, otherwise we get the appwindow's list.
        glb.popRegistry = window == _appWindow ? [] : null;

        //#endregion

        //#region private functions

        function _overlayItem() {
            this.type = null;
            this.params = null;
            this.container = null;
            this.domElement = null;
            this.ghost = null;
            this.onClose = null;//Optional onClose method that runs when close is triggered
        }

        _overlayItem.prototype.close = function (closeArgs) {
            var _thisOutObj = this;
            _removeFromOverlay(_thisOutObj.container, _thisOutObj.domElement, _thisOutObj.ghost);

            delete _thisOutObj.container;
            delete _thisOutObj.domElement;
            delete _thisOutObj.ghost;

            if (typeof _thisOutObj.onClose === _f) _thisOutObj.onClose(closeArgs);

            delete _thisOutObj.onClose;
            delete _thisOutObj.close;

            //console.log('closed:', _popupQueue.length);
            // Now this popup is closed, remove it from the queue and trigger the next queued popup (unless popups are deferred)
            _popupQueue.splice(_popupQueue.findIndex(function (i) { return i.popupID === _currentlyOpenID }), 1);
            //console.log('spliced:', _popupQueue.length);

            _currentlyOpenID = null;
            glb.runPopupQueue();
        };

        // Add to the dialog overlay and return the popup's container object
        function _addToOverlay(popupContainer, transparent, callerWindow) {
            var overlayid = 'dialog';
            var doc = (!!callerWindow ? callerWindow.document : _appWindow.document);
            var overlay = doc.getElementById(overlayid);//Get the existing dialog overlay

            if (!overlay) {
                overlay = doc.createElement(_div);//Or create the overlay element
                overlay.id = overlayid;
                if (!!transparent) {
                    overlay.className = 'noback';//remove dark background from overlay when transparent is true
                } else {
                    $('html').addClass("dom-popup-open");
                }
                doc.body.appendChild(overlay);//Finally, add the overlay element and its contents to the top level window's page if it doesn't exist.
            }

            overlay.appendChild(popupContainer);//Add the window to the overlay

            return popupContainer;
        }

        function _removeFromOverlay(containerToRemove, domElement, ghost) {
            // If ghost and dom elements are provided, replace the ghost with the original element.
            if (!!ghost && !!domElement) ghost.parentNode.replaceChild(domElement, ghost);

            var parent = containerToRemove.parentNode;
            parent.removeChild(containerToRemove);//Remove the chosen window from the overlay
            //If the overlay is empty, remove it
            if (!parent.children.length) {
                parent.parentNode.removeChild(parent);
                $('html').removeClass("dom-popup-open");
            }
        }

        function _blockError(originatorString) {
            glb.showConfirm({ headerIcon: 'warning', addClasses: ['errorpopup'], title: 'Operation timed out', message: 'This page may have encountered an error or\nis taking too long to respond. Please refresh\nthe page or click another link.' });
            if (typeof (originatorString) !== _u) {
                console.error('global.blockAction error: ' + originatorString);
            }
            glb.unBlock();
        }


        function _getNewWindowSize(width, height, invert) {//return a scaled window
            return { width: width, height: height };
        }

        function _appendObjectKeysToHTML(obj, htmlContent) {
            var newContent = "<table><tbody>";


            for (var key in obj) {
                newContent += "<tr><td valign='top'>" + key + "</td><td>";

                if (typeof obj[key] == 'object' && !_isEmptyObject(obj[key])) {
                    newContent += _appendObjectKeysToHTML(obj[key], newContent);
                } else {
                    newContent += '<pre>' + tios.util.htmlEntities(obj[key] instanceof Date ? obj[key].toISOString() : obj[key])/*.replace('\r\n','<br/>')*/ + '</pre>';
                }
                newContent += "</td></tr>";
            }

            newContent += "</tbody></table>";
            return newContent;
        }

        function _isEmptyObject(obj) {
            for (var prop in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                    return false;
                }
            }
            return true;
        }

        //#endregion

        //#region public functions


        glb.onFullscreen = function (isFullscreen) {
            var nowFullScreen = window.top.document.isFullScreen;//default to getting current top window state (from the isFullSscreen property added by display.js)
            if (typeof (isFullscreen) !== _u) {
                nowFullScreen = isFullscreen;//use state passed by event if present
            }

            if (nowFullScreen) {
                $('html').addClass('fullscreen');
            } else {
                $('html').removeClass('fullscreen');
            }
        };

        // Unused
        glb.onceObjectsLoaded = function (callback) {
            var $objects = $('object:not([data-loaded="true"])');
            if ($objects.length > 0) {
                $objects.on('load', function () {
                    //Once finished loading, remove the loading class
                    $(this).attr('data-loaded', 'true');

                    if ($('object:not([data-loaded="true"])').length == 0) {
                        //This part runs once all images loaded
                        callback();
                    }

                });
            } else {
                callback();
            }
        };

        // Enable/disable popups by deferring them
        glb.deferPopups = function (deferred, triggerNowIfUndeferred) {
            // Only perform these actions if the state changes
            if (deferred !== _deferPopups) {
                _deferPopups = deferred;

                //console.log('%cpopups now ' + (deferred ? 'deferred' : 'un-deferred'), 'color: red;');

                if (!_deferPopups && triggerNowIfUndeferred) {
                    //console.log('running queue on undeferred');
                    glb.runPopupQueue();
                }
            }
        };

        // Undefer popups, but don't trigger immediately by default (for use in onclose methods, so the enclosing onClose triggers afterwards)
        glb.unDefer = function (triggerNow) { glb.deferPopups(false, triggerNow || false);}

        glb.showPopupQueue = function () {
            return _popupQueue;
        };

        // Call close on all popups
        glb.closePopupQueue = function () {
            for (var pop of _popupQueue) {
                pop.close();
            }
        };

        glb.runPopupQueue = function () {
            // Here we call the required show method, but passing in the queued item - we do not need to return it as the originator's handle will be updated with the properties.
            var popup = _popupQueue[0] || null;

            if (!!popup) {
                //console.log('opening popup as first in queue', popup.params.id);
                switch (popup.type) {
                    case 'dom':
                        glb.showDomPopup(null, popup);
                        break;
                    case 'window':
                        glb.showWindow(null, popup);
                        break;
                };
            }
        };

        glb.showDomPopup = function (passedParams, queuedObject) {//callerWindow (window ref), domID (string), multipleWindows (bool), hideOverlay (bool), windowClasses (array), contentClasses (array)
            // If not performing the display of a queued item, add it to the queue first
            if (!queuedObject) {

                // At this point, we can't save the dom state etc. so we simply push the parameters onto an array as a property of a new object
                // Later, this object will be retrieved from the queue and passed into this method, where the params will subsequently be deleted
                var newOut = new _overlayItem();
                newOut.params = passedParams;
                newOut.type = 'dom';
                newOut.popupID = ('popup' + _popupCount++);
                _popupQueue.push(newOut);

                // If it's not deferred and is the only popup queued, allow it to show now. (queue will be at least length one at this point)
                if (!_deferPopups && _popupQueue.length == 1) {
                    //console.log('showing only popup');
                    return glb.showDomPopup(null, newOut);// Call this method with the newly added object
                }
                // Otherwise, we just return the newly queued popup
                return newOut;
            } else {
                var _doc = document;// reference to the current document, purely for access to the createElement methods
                var domElement = _doc.getElementById((passedParams ? passedParams.domID : queuedObject.params.domID));

                if (!!domElement) {
                    var params = queuedObject.params;

                    var popupContainer = _doc.createElement(_div);//Create the container to put inside the overlay
                    popupContainer.id = params.domID + '_popcon';//Give the popup an id based on the domID of the element inside to aid close callback targeting

                    var popupWindow = _doc.createElement(_div);//Create the window to place inside the container

                    //Extra classes can be added as an array, apply those classes to the container object here.
                    if (params.windowClasses && params.windowClasses.length) {
                        popupWindow.classList.add(...params.windowClasses);
                    }

                    var content = _doc.createElement(_div);//Create the panel for contents
                    content.classList.add('dom-element');

                    //Extra classes can be added as an array, apply those classes to the content object here.
                    if (params.contentClasses && params.contentClasses.length) {
                        content.classList.add(...params.contentClasses);
                    }

                    var ghost = _doc.createElement(_div);
                    ghost.id = params.domID + '_ghost';

                    domElement.parentNode.insertBefore(ghost, domElement);
                    content.appendChild(domElement);

                    popupWindow.appendChild(content);//Add the content to the window
                    popupWindow.tabIndex = 0;//Make focusable
                    popupContainer.appendChild(popupWindow);
                    var containerRef = _addToOverlay(popupContainer, !!params.hideOverlay, (!!params.callerWindow ? params.callerWindow : null));//Add the window to the overlay

                    popupWindow.focus();//Focus the window so repeated enters in the screen behind get caught here instead
                    // If successful, return the references to the container, inserted domelement, and the ghost

                    // For the output, we're either creating a new object or modifying the one that was queued so the original caller has access to close etc. when updated
                    var outObj = queuedObject || new _overlayItem();

                    outObj.container = containerRef;
                    outObj.domElement = domElement;
                    outObj.ghost = ghost;

                    // Set the onClose method if passed
                    if (typeof params.onClose === _f) outObj.onClose = params.onClose;

                    _currentlyOpenID = outObj.popupID;

                    // Now remove the params property from the displayed object (trying to prevent circular references)
                    delete outObj.params;

                    //console.log('global.showDomPopup rendered: ', params);

                    // Unblock on opening
                    glb.unBlock();

                    return outObj;
                } else {
                    //console.log('Dom element not found', params.domID);
                }
            }
            // On failure, return nothing
            return null;
        };

        //#region navigation functions

        glb.blockNav = function (callback, once) {
            // If the function is passed, set that as the onbeforeunload, or null
            _appWindow.global.blockNavFn = (typeof callback === _f ? callback : null);

            _appWindow.onbeforeunload = function () {
                var disallowNav = false;

                // Trigger the callback
                if (_appWindow.global.blockNavFn !== null) {
                    disallowNav = true;
                    _appWindow.global.blockNavFn();
                }

                // If being told to trigger only once, clear the event
                if (!!once) glb.unblockNav();

                // Now show the message
                return disallowNav;
            };
        };

        glb.unblockNav = function () {
            _appWindow.global.blockNavFn = null;
            _appWindow.onbeforeunload = _defaultUnload;
        };

        glb.navApp = function (url, ignoreBlocking, replaceLastPageInHistory) {

            // Allow blocking to take place if the callback is set and ignore is not
            if (_appWindow.global.blockNavFn !== null && !ignoreBlocking) {
                _appWindow.global.blockNavFn();
            } else {
                // If ignoring the blocking ...
                // Undo the global blocknav
                glb.unblockNav();
                glb.unBlock();

                var newUrl = vars.SiteUrl + url;
                //console.log('navapp to', newUrl);
                // Now navigate (or replace history)
                if (replaceLastPageInHistory) {
                    _appWindow.location.replace(newUrl);
                } else {
                    _appWindow.location.href = newUrl;
                }
            }
        };

        //#endregion navigation functions

        // TODO remove - not used anywhere
        glb.reloadPage = function () {//reload and force getting new copy of page
            location.reload(true);
        };

        /**
         * Opens a confirm dialog box
         * @function showConfirm
         * @param {{addClasses: Array.<string>, title: string, headerIcon: string, message: string, callback: function, textInput: bool, password: bool, cancel:string, ok: string }} params
         */
        glb.showConfirm = function (params) {
            //console.log('showConfirm called');
            var docCe = function (el) { return document.createElement(el) };
            var docCeNS = function (ns, el) { return document.createElementNS(ns, el) };

            // params:
            // headerIcon: the icon for the top left of the header bar
            // title: the title for the dialog
            // message: the main body text
            // addClasses: extra classes to add to the conteent element
            // ok: optional, overrides the ok button text (always shows as Ok otherwise)
            // cancel: cancel button text - does not show if it's not provided
            // callback: function that is triggered on ok/cancel. If textbox/password is showing, returns that text, otherwise returns ok/true cancel/false
            // textinput: if true, shows a text box
            // password: if true, shows a text box with password asterisks

            var content = docCe(_div);//Create the panel for contents
            content.classList.add('confirm');

            //Extra classes can be added as an array, apply those classes to the content object here.
            if (params.addClasses && params.addClasses.length) {
                content.classList.add(...params.addClasses);
            }

            if (params.title && params.title.length) {//Add the title if specified
                var header = docCe('header');
                var headerTitle = docCe('h1');

                headerTitle.innerText = params.title;
                if (params.headerIcon) {
                    var headerSvg = docCeNS(_svgns, 'svg');
                    var headerUse = docCeNS(_svgns, 'use');
                    headerUse.setAttributeNS(_xlnkns, 'href', (tios.util.cdnUrl('images-svg/icon-symbols.svg') + '#' + params.headerIcon));

                    headerSvg.appendChild(headerUse);
                    header.appendChild(headerSvg);
                }

                header.appendChild(headerTitle);//Append the title after the icon so they appear in that order in the header
                content.appendChild(header);
            }

            if (params.message && params.message.length) {//Add the text if specified
                var message = docCe(_div);
                message.classList.add('confirm-body');
                message.innerHTML = params.message.replace(/\n/g, '<br />');//Convert newlines to br for front end
                content.appendChild(message);
            }

            //Create a callback placeholder that will allow us to call the passed callback without modifying it, regardless of whether it's present or not
            var callbackAndClose = function (event) {
                _removeFromOverlay(content);
                if (params.callback && typeof params.callback === _f) {
                    params.callback(event);
                }
            };

            var inputbox = null;
            if (params.textinput || params.password) {
                // add an input box
                inputbox = docCe('input');
                if (params.password) {
                    inputbox.type = 'password';
                    inputbox.name = 'password';
                    inputbox.autocomplete = 'new-password';
                }

                inputbox.onkeyup = function (event) {
                    if (event.keyCode == 13) {
                        callbackAndClose(inputbox.value);
                    }
                };

                if (!!params.inputRequired) {
                    inputbox.oninput = function (event) {
                        if (!!event.target.value.length) {
                            okButton.classList.remove('disabled');
                        } else {
                            okButton.classList.add('disabled');
                        }
                    };
                }

                content.appendChild(inputbox);
            }

            var footer = docCe('footer');//Create a bar for ok/cancel

            var okButton;
            //Always create an ok button but override the text if provided
            okButton = docCe(_button);
            if (params.ok && params.ok.length) {
                okButton.innerText = params.ok;
            } else {
                okButton.innerText = 'Ok';
            }

            if (inputbox && !!params.inputRequired) {
                okButton.classList.add('disabled');
            }

            //On click of ok, return either the input text (if provided) or true
            okButton.onclick = function () {
                callbackAndClose(inputbox ? inputbox.value : true);
            }
            footer.appendChild(okButton);

            var cancelButton;
            if (params.cancel && params.cancel.length) {//Create cancel button if required
                cancelButton = docCe(_button);
                cancelButton.innerText = params.cancel;
                cancelButton.onclick = function () {
                    callbackAndClose(false);
                }
                footer.appendChild(cancelButton);
            }

            content.tabIndex = 0;//Make focusable
            content.appendChild(footer);//Add the savebar to the window container

            _addToOverlay(content, false, _appWindow);//Add the window to the overlay

            content.focus();//Focus the window so repeated enters in the screen behind get caught here instead

            // If there's no input box, make enter fire the close event as though ok was clicked
            if (inputbox == null) {
                content.onkeyup = function (event) {
                    if (event.keyCode == 13) {
                        callbackAndClose(true);
                    }
                }
            }

            // Unblock on opening confirm dialog
            glb.unBlock();

        };
        
        glb.toolTip = function (e, showing, content, colour) {
            if (showing) {
                var $target = $(e.target || e.srcElement || e);
                var $tooltipelement = null;
                var $tooltipcontent = null;

                var $tooltipToShow = null;//tooltip to show on showing (set later)
                if ($target.attr('data-tooltipselector')) {
                    $tooltipelement = $($target.attr('data-tooltipselector'));//use the attribute as the selector
                } else {
                    if ($target.attr('data-tooltipcontent')) {
                        $tooltipcontent = $target.attr('data-tooltipcontent');//use the data-tooltipcontent for the contents of a new span, or if doesn't exist...
                    } else {
                        $tooltipcontent = $target.next('.tooltipcontent');//... use the next .tooltipcontent element
                    }
                }

                //Display new tooltip and store reference in lastToolTip
                var showNew = function ($element) { $element.show(); $element.css({ 'opacity': '1' }); _$lastToolTip = $element; };

                if (!$tooltipelement) {//no specific tooltip element to use, so use the general tooltip overlay
                    var hasContainer = false;
                    if ($tooltipcontent.length) {
                        hasContainer = true;
                    }
                    if (content == null) {
                        if (hasContainer) content = (typeof ($tooltipcontent.html) != _u ? $tooltipcontent.html() : $tooltipcontent);//use the targeted content container as-is, or use the string
                    } else {
                        content = content.replace(/(?:\r\n|\r|\n)/g, '<br/>');
                    }

                    var tooltipx = 0;
                    var tooltipy = 0;

                    if ($target.attr('data-tooltipx')) {
                        tooltipx = $target.offset().left + parseFloat($target.attr('data-tooltipx'));//using data-tooltipx and y as original design size pixels 
                    } else {
                        tooltipx = $target.offset().left + $target.width() + 1 ;
                    }
                    if ($target.attr('data-tooltipy')) {
                        tooltipy = $target.offset().top + parseFloat($target.attr('data-tooltipy'));
                    } else {
                        tooltipy = $target.offset().top;
                    }

                    var targetWindow = (window != _appWindow ? _appWindow : window);

                    $tooltipToShow = targetWindow.$("#tooltip");

                    if (!$tooltipToShow.length) { //tooltip does not exist in parent page, so create it
                        $tooltipToShow = $('<div id="tooltip">');
                        $tooltipToShow.appendTo(targetWindow.$(_body));
                    }

                    //TODO Rework this to work with fancybox
                    if (targetWindow != window) {
                        var $windowframe = targetWindow.$('.fancybox-iframe');//grab the window that is open
                        $tooltipToShow.css({
                            top: ($windowframe.offset().top + tooltipy) + 'px',
                            left: ($windowframe.offset().left + tooltipx) + 'px'
                        });
                    } else {
                        $tooltipToShow.css({
                            top: (tooltipy) + 'px',
                            left: (tooltipx) + 'px'
                        });
                    }

                    //if (showing) {
                    $tooltipToShow.html(content);//set the tooltip html to the content of the tooltip in the page when showing, do not change it when fading out
                    if (hasContainer && typeof ($tooltipcontent.attr) != _u) {//use tooltipcontent's classes on the tooltip popup (excluding the actual 'tooltipcontent' class), but only when making visible
                        $tooltipToShow.attr('class', $tooltipcontent.attr('class').replace('tooltipcontent', ''));
                    }
                    if (colour) {
                        $tooltipToShow.css({ borderColor: colour });
                    }
                    //}
                } else {
                    //Using a specific tooltipelement
                    $tooltipToShow = $tooltipelement;
                }

                if (_$lastToolTip) {
                    _$lastToolTip.stop(true, true).fadeIn(500, function () { showNew($tooltipToShow); });
                } else {//last tooltip does not exist, just show new
                    showNew($tooltipToShow);
                }
            }
            else {//hide the last shown tooltip
                if (_$lastToolTip) {
                    _$lastToolTip.stop().fadeOut(500, function () { $(this).hide(); });
                }
            }
        };
        glb.showTooltip = function (e) { glb.toolTip(this, true, null, null); };
        glb.hideTooltip = function (e) { glb.toolTip(this, false, null, null); };

        glb.hint = function (element, showing) {
            var $element = $(element);
            if (showing) {
                if ($element) {
                    $element.stop(true, true).fadeIn(500, function () { $element.show(); $element.css({ 'opacity': '1' }); });
                }
            }
            else {//hide the last shown tooltip
                if ($element) {
                    $element.stop().fadeOut(500, function () { $(this).hide(); });
                }
            }
            $element.click(function () {
                glb.hideHint(this);
            });
        };
        glb.showHint = function (e) { glb.hint(e, true); };
        glb.hideHint = function (e) { glb.hint(e, false); };
        glb.showAllHints = function () { $('[data-hint]').each(function () { glb.showHint(this); }); };
        glb.hideAllHints = function () { $('[data-hint]').each(function () { glb.hideHint(this); }); };

        //Callback for validateunique to show tooltip warning
        glb.tooltipMessage = function (sender, data) {
            if (data.count > 0 && data.message && data.matches) {
                glb.toolTip(sender, true, data.message + data.matches.join('\n'), '#f00');
            } else if (data.count > 0 && data.message) {
                glb.toolTip(sender, true, data.message, '#f00');
            } else if (data.count == 0) {
                glb.toolTip(sender, false);
            }
        };

        glb.blockAction = function (originatorString) {
            //use body class
            // We need to swap around the classes, otherwise the cursor state can persist until the mouse is moved
            // upon navigating to a new page
            _appWindow.$(_body).removeClass('unblocked').addClass('blocked');
            if (_appWindow.global.blockTimer) _appWindow.global.blockTimer.clear();//clear timer before starting
            //only show error if blockdiv is actually found (it may have been removed but the timer not cleared)
            _appWindow.global.blockTimer = new tios.util.TIOSTimeout('global.blockaction.bodyblockaction _appWindow.global.blockTimer', function () {
                //console.log('body is blocked: ' + _appWindow.$(_body).hasClass('blocked'));

                if (_appWindow.$(_body).hasClass('blocked')) {
                    _blockError(originatorString);
                }
            }, _appWindow.global.blockTimeoutDuration);  
        };

        glb.unBlock = function () {
            //u se body class
            var $body = _appWindow.$('body.blocked');
            if ($body.length) {

                // We need to swap around the classes, otherwise the cursor state can persist until the mouse is moved
                // upon navigating to a new page
                $body.removeClass('blocked').addClass('unblocked');
                if (_appWindow.global.blockTimer) _appWindow.global.blockTimer.clear();

            }
        };

        glb.setupTabJump = function () {
            $(document).on('keydown', ':text', function (e) { //on keydown for all textboxes  
                if (e.keyCode == 13) //if this is enter key  
                {
                    e.preventDefault();//Block enter and jump to next tabindex
                    var tabindex = parseInt($(this).attr('tabindex'), 10);
                    // console.debug("index:"+tabindex);
                    if (tabindex) {
                        var searching = true;
                        var searchcount = 0;
                        while (searching && searchcount < 6) {//iterate until tabindex found or 5 jumps and none found
                            //   console.debug("seeking next:" + (tabindex + 1));
                            var $next = $('[tabindex=' + (tabindex + 1) + ']');
                            if ($next.length) {
                                //    console.debug("found next:" + $next.attr('tabindex'));
                                if ($next.is(':image, a')) {
                                    $next.click();
                                } else {
                                    $next.focus();
                                }
                                searching = false;
                            } else {
                                tabindex++;
                                searchcount++;
                            }
                        }
                    }
                }
            });
        };


        glb.popIsOpen = function (popupConf) {
            return _appWindow.global.popRegistry.indexOf(popupConf.id) >= 0;
        };

        glb.showPopup = function (params) {
            if (!glb.popupsBlocked) {
                var windowParams = {
                    name: 'Fancy',
                    id: params.conf.id,
                    allowCloseOutside: false,
                    cssClass: params.conf.cssClass,
                    width: params.conf.width,
                    height: params.conf.height,
                    onClose: params.onClose,
                    openArgs: params.openArgs,
                    loadCallback: params.loadCallback,
                    url: params.conf.url,
                    query: params.query,
                    content: params.content,
                    queueJump: params.queueJump // If true, shows a popup immediately by pushing it to the top of the stack
                };
                //console.log('showwindow params', windowParams.id);
                glb.showWindow(windowParams);
            } else {
                //console.log('global.showPopup blocked: ', params);
            }
        };

        var _openArgsPrefix = 'openArgs_';

        //Returns openArgs from session storage and deletes it.
        glb.getOpenArgs = function (popup) {
            var argsID = _openArgsPrefix + (popup.id || '');
            var args = tios.util.getFromStorage(argsID, true);
            tios.util.convertDateStringsToDates(args);//make sure dates are dates
            tios.util.removeFromStorage(argsID, true);
            return args;
        };

        // Fancybox variant
        glb.showWindow = function (passedParams, queuedObject) {
            if (!glb.popupsBlocked) {

                // If not performing the display of a queued item, add it to the queue first
                if (!queuedObject) {

                    // Later, this object will be retrieved from the queue and passed into this method, where the params will subsequently be deleted
                    var newOut = {
                        params: passedParams,
                        type: 'window',
                        popupID: ('popup' + _popupCount++),
                    };

                    // If not jumping the queue, push this into the queue
                    if (!passedParams.queueJump) {
                        //console.log('pushing');
                        _popupQueue.push(newOut);
                    }

                    //console.log('global.showWindow queued: ', passedParams.id);
                    //console.log('queue', _popupQueue);

                    // If it's not deferred and is the only popup queued, allow it to show now. (queue will be at least length one at this point)
                    if (passedParams.queueJump || (!_deferPopups && _popupQueue.length == 1)) {
                        glb.showWindow(null, newOut);// Call this method with the newly added object
                    }
                } else {
                    glb.blockAction('showWindow');

                    //use fancybox
                    if (typeof _appWindow.$.fancybox == _f) {
                        var params = queuedObject.params;

                        var fbContent = null;
                        var fbParams = {
                            autoSize: false,

                            type: null,// unless specifying using iframe or specifying ajax.
                            scrolling: 'no',
                            wrapCSS: 'fbTIOS',
                            closeBtn: false,
                            modal: false,
                            padding: 0,
                            minWidth: 1,
                            minHeight: 1,
                            autoResize: false,
                            arrows: false,
                            //beforeClose:function(){ glb.unBlock(); return true;},
                            afterShow: function () { glb.unBlock(); },
                        };

                        if (!params.id) throw ("Window does not have params.id specified");

                        var argsID = _openArgsPrefix + params.id;

                        if (params.cssClass) {
                            fbParams.wrapCSS += ' ' + params.cssClass;
                        }

                        if (typeof params.autoCenter !== _u) {
                            fbParams.autoCenter = params.autoCenter;
                            fbParams.fitToView = false;
                        }

                        if (params.url) {
                            fbParams.type = _iframe;

                            var newUrl = params.url;
                            if (params.query) {
                                newUrl += (newUrl.indexOf('?') > -1 ? '&' : '?') + tios.util.buildParams(params.query);
                            }

                            fbContent = newUrl;
                        } else if (params.content) {
                            fbContent = params.content;
                        }

                        if (!params.useContentSize && params.width && params.height) {
                            var newSize = _getNewWindowSize(params.width, params.height);//scale full size dimensions

                            _appWindow.global.popupWindowInitialHeight = params.height;
                            _appWindow.global.popupWindowInitialWidth = params.width;

                            fbParams.width = newSize.width
                            fbParams.height = newSize.height;
                        } else if (params.useContentSize) {
                            var newSize;
                            //Disable all autosizing properties
                            fbParams.wrapCSS += ' ' + _csssizingclass;//set to csssize class so that we can tell the resize method not to bother resizing this window.
                            fbParams.autoCenter = false;//disable code-based centring because css does this
                            fbParams.fitToView = false;
                            fbParams.margin = 0;
                            fbParams.leftRatio = 0;
                            fbParams.topRatio = 0;
                            /*
                            if (params.content.nodeType) {
                                //get size specifier from data-popupwidth / data-popupheight attrs, or use the original dom render size to calculate
                                if (params.content.attributes['data-popupheight'] && params.content.attributes['data-popupwidth']) {
                                    newSize = _getNewWindowSize(params.content.attributes['data-popupwidth'].value, params.content.attributes['data-popupheight'].value);//scale full size dimensions
                                    fbParams.width = newSize.width
                                    fbParams.height = newSize.height;
                                } else {
                                    fbParams.width = params.content.offsetWidth;
                                    fbParams.height = params.content.offsetHeight;
                                    newSize = _getNewWindowSize(params.content.offsetWidth, params.content.offsetHeight, true);//work out what the full size would be (as this is scaled) and store it
                                }
                            }
                            if (newSize) {
                                _appWindow.global.popupWindowInitialHeight = newSize.height;
                                _appWindow.global.popupWindowInitialWidth = newSize.width;
                            }*/
                        }

                        fbParams.afterClose = function (args) {
                            //console.log('fancybox afterclose', args);
                            glb.unBlock();//callback here - declared below
                            tios.util.removeFromStorage(argsID, true); /*Remove the openArgs in case they were not cleared after opening*/

                            //If no onClose declared, use this default
                            if (typeof params.onClose == _f) {
                                //pass in the application level window Args as stored by the closeWindow function
                                //console.log('firing onClose for window',_appWindow.global.popupWindowCloseArgs);
                                params.onClose(_appWindow.global.popupWindowCloseArgs);//Fire the passed in onClose function, passing in the arguments
                                _appWindow.global.popupWindowCloseArgs = null;//Reset the _appWindow args once the function has been called

                                if (params.content) {
                                    $(params.content).show();//undo the automatic hide of once-shown content (otherwise it won't have content size when reused);
                                }
                            }

                            // Remove the popup's ID from the registry of open popups
                            _appWindow.global.popRegistry.splice(_appWindow.global.popRegistry.findIndex(function (i) { return i === params.id }), 1);

                            // Trigger the closure event so pages subscribing to this window being opened/closed can react accordingly
                            window.dispatchEvent(new CustomEvent(_popupEventHandler, { detail: { opened: false, id: params.id, window: null } }));

                            // Remove the popup from the queue of popups to open

                            var windowIndex = _popupQueue.findIndex(function (i) { return i.popupID === _currentlyOpenID });
                            //console.log('windowindex for ' + _currentlyOpenID + ' is ' + windowIndex);
                            // If the window is found in the queue, remove it from the list
                            if (windowIndex >= 0) {
                                _popupQueue.splice(windowIndex, 1);
                            }
                            _currentlyOpenID = null;

                            // If popups are not deferred, run the next one in the queue
                            if (!_deferPopups) {
                                //console.log('running queue, undeferred');
                                glb.runPopupQueue();
                            } else {
                                //console.log('not running queue, popups are deferred');
                            }
                        };//if run beforeclose, causes infinite loop

                        if (params.openArgs && fbParams.type == _iframe)//Set the data to be passed into the window (if it's an iframe)
                        {
                            if (!params.id || params.id.length == 0) console.error('window requires id to pass args');
                            tios.util.saveToStorage(argsID, params.openArgs, true);//Save the openargs to session storage for immediate referencing in opened popups
                            // Using sessions prevents it from being accessible across tabs

                            //Set the afterLoad of the fancybox to call the onOpen method within the window, passing in openArgs
                            fbParams.afterLoad = function () {
                                //Grab the window of the opened page and set the args
                                //this.content[0].contentWindow.openArgs = params.openArgs;

                                var fbwin = this.content[0].contentWindow;

                                if (typeof fbwin.onOpen == _f) {
                                    fbwin.onOpen(params.openArgs);//Trigger the onOpen function
                                }

                                // If no loadCallback defined, set it to an empty function now (prevents need to check in windows)
                                fbwin.openArgs = params.openArgs;// Push the args to a variable in the window
                                fbwin.loadCallback = params.loadCallback || function noop() { };

                                // Trigger the popup opened event with the ID
                                window.dispatchEvent(new CustomEvent(_popupEventHandler, { detail: { opened: true, id: params.id, window: fbwin } }));
                            };
                        } else {
                            tios.util.removeFromStorage(argsID, true);
                        }

                        if (params.allowCloseOutside) {
                            fbParams.modal = false;
                        } else {
                            fbParams.modal = true;
                        }

                        // wait until the fancybox object is truly ready (has the modal in place etc.) before firing, by triggering on document ready
                        $(document).ready(function () {
                            _appWindow.$.fancybox.open(fbContent, fbParams);

                            // Push the currently open window's ID onto the appwindow's popup registry
                            _appWindow.global.popRegistry.push(params.id);

                            _currentlyOpenID = queuedObject.popupID;
                        });
                    }
                }
            } else {
                //console.log('global.showWindow blocked: ', params);
            }
        };

        //Resize window, fancybox variant
        glb.resizeWindow = function (width, height) {//global.resizeWindow
            if (window !== _appWindow) {
                _appWindow.global.resizeWindow(width, height);
            } else {
                // This is the app window
                var newSize = _getNewWindowSize(width, height);

                //Resize an open fancybox
                if (typeof _appWindow.$.fancybox == _f) {//only run this on pages with fancybox
                    if (_appWindow.$.fancybox.current && _appWindow.$.fancybox.current.wrapCSS.indexOf(_csssizingclass) === -1) {//Only update the sizes in javascript if not using the css sizing.
                        _appWindow.$.fancybox.current.width = newSize.width
                        _appWindow.$.fancybox.current.height = newSize.height
                        _appWindow.$.fancybox.update();//enforce new size
                    }
                }
            }
        };

        //Check whether our fancybox window is open or not
        glb.isWindowOpen = function () {
            if (typeof _appWindow.$.fancybox == _f && _appWindow.$.fancybox.current) {
                return true;
            } else {
                return false;
            }
        };

        glb.closeActiveWindow = function (args) {//Closes any active window (usually from within the window)
            if (typeof args === _u) args = null;//map undefined to null
            glb.blockAction('global.closeActiveWindow()');

            if (glb.isWindowOpen()) {
                _appWindow.global.popupWindowCloseArgs = args;//pass args up to application level now that window no longer exists
                _appWindow.$.fancybox.close();
            }

            _appWindow.global.popupWindowInitialWidth = null;
            _appWindow.global.popupWindowInitialHeight = null;
        };

        //Scroll to an element within parent
        glb.scrollElement = function (rowSelector, parentSelector, timing) {
            var $selectedElement = $(rowSelector);
            if ($selectedElement.length) {
                $selectedElement.first().parents(parentSelector).animate({ scrollTop: ($selectedElement.offsetParent().scrollTop() + $selectedElement.position().top) + 'px' }, timing);
                return $selectedElement;
            } else {
                return null;
            }
        };

        // Deprecated requireoneofgroup method
        glb.checkRequiredGroups = function (caller, sender) {
            //console.log('checkRequiredGroups called by ' + caller);
            function _checkGroup(group) {

                var $all = $('[data-requireoneofgroup="' + group + '"]');
                $all.attr(_required, _required);

                var foundValid = false;

                //loop until at least one valid item found
                $all.each(function () {
                    if (this.checkValidity()) {
                        foundValid = true;
                        return false;//break
                    }
                });

                if (foundValid) {//remove validation from others
                    $all.removeAttr(_required);
                }
            }

            if (sender) {
                //check the sender's group for required inputs
                var groupname = $(sender).attr('data-requireoneofgroup');
                if (groupname && groupname.length) {
                    _checkGroup(groupname);
                }
            } else {
                //check the page for required groups and build a list
                var $requiredgroupcontrols = $('[data-requireoneofgroup]');
                var grouplist = [];
                $requiredgroupcontrols.each(function () {
                    var groupname = $(this).attr('data-requireoneofgroup');
                    if (grouplist.indexOf(groupname) < 0) {
                        //add if not already in list
                        grouplist.push(groupname);
                    }
                });
                //iterate the new list and check each group in turn
                if (grouplist.length) {
                    for (var i = 0; i < grouplist.length; i++) {
                        _checkGroup(grouplist[i]);
                    }
                }
            }

        };

        glb.highlighter = function (caller, parentselector) {

            //console.log('highlighter called by ' + caller);

            var highlightselector = '[data-highlight]';
            var inputSelector = 'input, textarea';
            var customSelector = 'dropdown';
            var emptyclass = 'empty';
            var invalidclass = 'invalid';

            var invalidcount = 0;
            var highlightcount = 0;
            var emptycount = 0;
            var filledcount = 0;

            if (parentselector && parentselector.length) {
                highlightselector = parentselector + ' ' + highlightselector;
            }

            $(highlightselector).each(function () {

                var $container = $(this);

                if ($container.is(':visible')) {
                    var parentcomplete = true;
                    var parentvalid = true;

                    var highlightoption = $container.attr('data-highlight');

                    var $inputs;

                    switch (highlightoption) {
                        case 'all':
                            $inputs = $container.find(inputSelector + ', ' + customSelector);//all inputs, even nested in other highlighters
                            break;
                        default:
                            $inputs = $container.children(inputSelector + ', ' + customSelector);//only first descendants
                            break;
                    }

                    $inputs.each(function () {
                        var $this = $(this);
                        var isHidden = $this.attr('type') == 'hidden';
                        var isRequired = $this.hasClass('ng-required') || $this.attr(_required) == _required;
                        var isEmpty = ($this.val().length == 0 && !$this.hasClass('ng-not-empty')) || $this.hasClass('ng-empty');
                        var isInValid = $this.hasClass('ng-invalid-required') || $this.hasClass('ng-invalid-pattern') || ($this.is(inputSelector) && !$this.get(0).checkValidity());

                        //if not hidden and invalid, or if hidden and length zero, it's invalid
                        if ((/*!isHidden &&*/ isInValid) || (isEmpty && isRequired)) {
                            //is it invalid or required but empty
                            parentvalid = false;
                            return false;//break out
                        } else {
                            //is it just empty
                            if (isEmpty) {
                                parentcomplete = false;
                                return false;//break out
                            }
                        }
                    });

                    highlightcount++;

                    if (parentvalid) {
                        $container.removeClass(invalidclass);
                        if (parentcomplete) {
                            $container.removeClass(emptyclass);
                            filledcount++;
                        } else {
                            emptycount++;
                            $container.addClass(emptyclass);
                        }
                    } else {
                        $container.addClass(invalidclass);
                        invalidcount++;
                    }
                }
            });
            return { invalid: invalidcount, count: highlightcount, empty: emptycount, filled: filledcount };
        };

        glb.showError = function (response, caller) {
            //console.error('showerror', response);
            glb.unBlock();
            if (!glb.loggingOut) {//do not make this popup show if it's due to authentication (the user is being logged out)
                var alertHTML = 'Please click OK and try again.';
                var htmlType = 'text/html';
                //var errMsg = '';

                var rd = response.data || null;
                //var rj = response.responseJSON || null;
                //var rt = response.responseText || null;

                //var dataIsHtml = (typeof response.headers === _f && (response.headers()['content-type'] || '').indexOf(htmlType) > -1) || (typeof response.getResponseHeader === _f && (response.getResponseHeader('Content-Type') || '').indexOf(htmlType) > -1);

                //var usePre = true; // Default to using pre tags for output

                // If there's a returned error ID, display only that with the error message;
                if (rd && rd.ErrorID) {
                //    alertHTML = errMsg + rd.ErrorID;
                    usePre = false; // Don't use a pre tag as the message looks horrid
                } else if (rd && rd.ErrorMessage) { // If this is just a plain message to show the user, do this now
                    alertHTML = rd.ErrorMessage;
                    usePre = false; // Don't use a pre tag
                }
                //else {
                //    if (dataIsHtml) {
                //        if (rd) {
                //            alertHTML = rd;
                //        } else if (rt) {
                //            alertHTML = rt;
                //        }
                //    } else {
                //        if (rj) {
                //            if (rj.ErrorID) {
                //                alertHTML = errMsg + rj.ErrorID;
                //            } else {
                //                alertHTML += _appendObjectKeysToHTML(rj, alertHTML);
                //            }
                //        } else if (rd) {
                //            if (typeof rd == _s) {
                //                alertHTML += rd;
                //            }
                //            else if (rd.Message) {
                //                alertHTML += rd.Message;
                //            } else {
                //                alertHTML += _appendObjectKeysToHTML(rd, alertHTML);
                //            }
                //        } else if (response.ErrorMessage) {
                //            alertHTML = response.ErrorMessage;
                //        }
                //    }
                //}

                //if (alertHTML.length) {
                //    if (dataIsHtml) {
                //        var newWindow = window.open('', 'Error', 'location=no,toolbar=0');
                //        newWindow.document.open();
                //        newWindow.document.write(alertHTML);
                //        newWindow.document.close();
                //    } else {
                //        if (usePre) {
                //            alertHTML = '<pre>' + alertHTML + '</pre>';
                //        }

                        glb.showConfirm({ title: 'Something went wrong', message: alertHTML, isHtml: true, addClasses: ['errorpopup', 'groerror'] });
                //    }
                //}

            }
        };

        
        //Finally, run this when the document is ready
        glb.launch = function () {
            //console.log('global.launch called');
            glb.onFullscreen();

            //fullscreen behaviour

            if (window.top.fshandler && window.top.fshandler.fullscreencapable) {
                var $fullscreenbutton = tios.util.addToTiosBar('<div class="fullscreen" style="" title="Full screen"></div>');

                if ($fullscreenbutton) {
                    $fullscreenbutton.click(function (event) {
                        window.top.document.toggleFullScreen(event);
                    });
                }
            }

            //Set focus on marked controls
            $('input.DefaultFocus, .DefaultFocus input').focus();

            // Enable tooltip framework
            //_bindTooltips();


            //setTimeout(function () { $('html').addClass('wf-active').removeClass('wf-inactive');}, 4000);//fallback for non-loading webfont
            //Prevent context menu on specified elements.
            $('.NoContext').on('contextmenu', function (e) { return false; });
        }

        //#endregion




        //#region external configuration


        /* // This is presently not implemented
        //replace the content of an element that has data-overcontent attribute with that attribute on rollover and on rolloff set the content to data-offcontent
        $("body").on({
            mouseenter: function () {
                var overcontent = $(this).attr('data-overcontent');
                if (overcontent) {
                    if (overcontent == '&nbsp;') {
                        overcontent = '-';
                    }
                    $(this).html(overcontent);
                }
            },
            mouseleave: function () {
                var offcontent = $(this).attr('data-offcontent');
                if (offcontent) {
                    $(this).html(offcontent);
                }
            },
        }, "[data-overcontent]");
        */

        //Trigger removal of blockaction when leaving a page, so returning does no cause the page to be blocked on cached versions (not necessary because of below)
        window.onbeforeunload = _defaultUnload;//This line for some reason causes the browser to not cache the previous page's render (which is desirable, or outdated information may be shown)

        //#endregion
        
        return glb;
    }(global || {}, jQ));

    if (!!angular) {
        var globalModule = angular.module('globalModule', []);
        globalModule.constant('globalUtil', global);// Using constants so they can be referenced in config blocks
    }

    window.global = global;

})();